/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';

import { Form } from 'cvlib';

import './facebookErrorModal.scss';

const FacebookErrorModal = props => {
  const {
    home_ticker_icon_button_close,
    mail_modal_icon_warning,
  } = props.asset;
  const { error_message, onCloseModal } = props;

  const elements = [
    {
      element: 'logo',
      content: mail_modal_icon_warning,
      expand: 3,
      position: 'center',
      style: { width: '44px', height: '40px' },
    },
    {
      element: 'message',
      content: error_message,
    },
  ];

  return (
    <div className="modal-form-register-error-container">
      <Form
        elements={elements}
        classes={['modal-form-register-error']}
        style={{ width: '19.5rem', height: '18rem' }}
      />
      <img
        alt="Close"
        className="modal-form-register-error-close"
        src={home_ticker_icon_button_close}
        onClick={onCloseModal}
      />
    </div>
  );
};

FacebookErrorModal.propTypes = {
  translations: PropTypes.shape({
    error_mail_modal_title_label: PropTypes.string,
  }),
  asset: PropTypes.shape({
    home_ticker_icon_button_close: PropTypes.string,
    mail_modal_icon_warning: PropTypes.string,
  }),
  error_message: PropTypes.string,
  onCloseModal: PropTypes.func,
};

export default FacebookErrorModal;
